// 处理材料图片（材料图片需要拼接链接）
const stitchingImages = (data) => {
  let picJsonList = []
  if (!data) {
    return picJsonList
  }
  let urlHearder = localStorage.getItem('imageDomainName')
  if (data.parentId === '0') {
    if (data.picJson) {
      picJsonList = JSON.parse(data.picJson).map(citem => {
        citem.fileUrl = urlHearder + citem.fileStorePath + '/' + citem.filesIn
        return citem
      })
    } else {
      if (this.inputForm.mainItemPicture) {
        let splitData = this.inputForm.mainItemPicture.split('|')
        this.inputForm.picJsonList = splitData.map(citem => {
          let itemUP = {
            fileStorePath: 'item/' + data.mainItemCode + '/' + citem,
            filesIn: citem,
            remarks: '',
            fileUrl: this.urlHearder + 'item/' + data.mainItemCode + '/' + citem
          }
          return itemUP
        })
      } else {
        let splitData = this.inputForm.picture.split('|')
        this.inputForm.picJsonList = splitData.map(citem => {
          let itemUP = {
            fileStorePath: 'item/' + data.code + '/' + citem,
            filesIn: citem,
            remarks: '',
            fileUrl: this.urlHearder + 'item/' + data.code + '/' + citem
          }
          return itemUP
        })
      }
    }
  } else {
    if (data.picture) {
      let splitData = data.picture.split('|')
      picJsonList = splitData.map(citem => {
        let itemUP = {
          fileStorePath: 'item/' + data.code + '/' + citem,
          filesIn: citem,
          remarks: '',
          fileUrl: urlHearder + 'item/' + data.code + '/' + citem
        }
        return itemUP
      })
    } else {
      picJsonList = []
    }
  }
  return picJsonList
}

export default {stitchingImages}
